module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hEy2p"))).then(() => parcelRequire('iDabs'));